module.exports = __webpack_public_path__ + "static/media/this_week.27f65acd.png";